import { z } from 'zod'

export const zImageTypeEnum = z.enum(['PRIMARY', 'GALLERY'])

export type ImageTypeEnumSchema = z.infer<typeof zImageTypeEnum>
